export const contentTableConfig = {
  propList: [
    {prop: 'customerName', label: '客户姓名', minWidth: '60'},
    {prop: 'custNickName', label: '客户昵称', minWidth: '60'},
    {prop: 'exploitAccount', label: '开发账号', minWidth: '60'},
    {prop: 'fundsDesc', label: '资金量（万）', minWidth: '50', sortable: 'custom'},
    {prop: 'proofImgUrls', label: '资金证明图', minWidth: '40', slotName: 'proofImgUrls'},
    {prop: 'proveTeacherStr', label: '认可老师', minWidth: '50'},
    {prop: 'proveImgUrls', label: '认可老师证明图', minWidth: '40', slotName: 'proveImgUrls'},
    {prop: 'recordingUrls', label: '录音', minWidth: '40', slotName: 'recordingUrls'},
    {prop: 'remark', label: '备注', minWidth: '80'},
    {prop: 'openDate', label: '开单日期', minWidth: '80', sortable: 'custom'},
    {prop: 'empName', label: '员工', minWidth: '50'},
    {prop: 'verifyResult', label: '业绩核实结果', minWidth: '60', slotName: 'verifyResult'},
    {label: '操作', minWidth: '150', slotName: 'handler'}
  ],
  showSelectColumn: true,
  action: process.env.VUE_APP_BASE_URL + '/main/fundsVerification/dataImport'
}
